var getScheduledAutopayAmount = function (accountDetails, isSetpayAccount) {
    var _a = accountDetails || {}, billing = _a.billing, enrollmentDetails = _a.enrollmentDetails, installment = _a.installment;
    var _b = billing || {}, totalMinimumPaymentDue = _b.totalMinimumPaymentDue, statementBalance = _b.statementBalance;
    var _c = enrollmentDetails || {}, paymentAmount = _c.paymentAmount, paymentOption = _c.paymentOption;
    var monthlyAmountDue = (installment || {}).monthlyAmountDue;
    if (Number(paymentAmount)) {
        return paymentAmount;
    }
    if (!isSetpayAccount) {
        switch (paymentOption) {
            case 'MINIMUM_PAYMENT_DUE':
                return totalMinimumPaymentDue;
            case 'STATEMENT_BALANCE':
                return statementBalance;
            default:
                return paymentAmount;
        }
    }
    else
        return monthlyAmountDue;
};
export default getScheduledAutopayAmount;
